import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {Avatar} from 'components/common/app';
import {CardContainer, Notification, Loading, Button} from 'components/common/uiKit';

import {serverUrl} from 'services/network';
import * as RouteService from 'services/route'
import {OrderApi} from 'services/network/api';

var jMoment = require('moment-jalaali');


class BillDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            steps: [],
            selectedStep: 0,
            loading: false,
            submitLoading: false
        };
    }

    componentDidMount() {
        this.getQsData();
    }

    getQsData() {
        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (!qs || !qs.id) {
            Notification('error', 'WrongParams');

            const {history} = this.props;
            history.goBack();
        }

        this.setState({id: qs.id}, () => {
            this.loadSteps();
            this.loadData();
        });
    }

    loadSteps() {
        OrderApi.GetOrderSteps()
            .then(res => {
                if (res && res.status == 200) {
                    const {locale} = this.props;
                    const pageTranslates = locale.translation.Pages.Admin.Bill.Steps;

                    let {data} = res;
                    data = data.map(x=>{
                        const item = {id: x.id, name: pageTranslates[x.name]};
                        return item;
                    });
                    this.setState({steps: data});
                }
            });
    };

    loadData() {
        const {id} = this.state;

        if (id) {
            this.setState({loading: true});
            OrderApi.GetBillDetail(id)
                .then(res => {
                    const {data} = res;
                    this.setState({data, selectedStep: data.step});
                }).finally(x => {
                this.setState({loading: false});
            });
        }
    }

    handleDetail = (key, value) => {

        return (
            <>
                <div className='text-center col-6 color-primary font-weight-bold'>
                    {key}
                </div>
                <div className='text-center col-6'>
                    {value}
                </div>
            </>
        );
    };

    handleStatus = (step) => {
        let type = {
            color: 'bg-dark1-light',
            icon: 'spinner'
        };

        switch (step.toLowerCase()) {
            case 'succeedpayment':
                type.color = 'bg-green1-dark';
                type.icon = 'check';
                break;
            case 'unsucceedpayment':
                type.color = 'bg-red1-dark';
                type.icon = 'times';
                break;
            case 'notapproved':
                type.color = 'bg-red1-dark';
                type.icon = 'ban';
                break;
        }

        return (
            <div
                className={`${type.color} rounded-circle d-flex justify-content-center align-items-center`}
                style={{width: 30, height: 30}}>
                <i className={`fa fa-${type.icon}`}/>
            </div>
        )
    };

    handleSubmit = () => {
        const {id, selectedStep} = this.state;
        if (id) {
            this.setState({submitLoading: true});
            const data = {id: parseInt(id), step: parseInt(selectedStep)};

            OrderApi.Update(data)
                .then(res => {
                    if (res && res.status == 200)
                        Notification('success', 'Succeed');
                }).finally(x => {
                this.setState({submitLoading: false});
            })
        }
    };

    handleBack = () => {
        this.props.history.goBack();
    };

    selectChange = event => {
        const selectedStep = event.target.value;

        this.setState({selectedStep});
    };

    render() {
        const {data, loading, submitLoading} = this.state;

        if (loading || !data)
            return <Loading/>;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.Bill.Details;

        const {steps, selectedStep} = this.state;

        const {
            courseName,
            courseImage,
            username,
            userImage,
            userFullName,
            price,
            stepTitle,
            paymentTypeTitle,
            createdDate,
            modifiedDate,
            ownerName,
            cardNumber,
            trackingCode
        } = data;

        const courseImageUrl = `${serverUrl}${courseImage.split('\\').join('/')}`;
        const userImageUrl = userImage ? `${serverUrl}${userImage.split('\\').join('/')}` : '';

        const jCreateDate = jMoment(createdDate).format('jYYYY/jMM/jDD - HH:mm:ss');
        const jModifiedDate = jMoment(modifiedDate).format('jYYYY/jMM/jDD - HH:mm:ss');

        return (
            <CardContainer>
                <div className='row'>
                    <div className='col-12'>
                        <div className='float-right'>
                            <div className='text-right'>
                                <h5 className='color-primary mb-0'>
                                    {courseName}
                                </h5>
                                <small className='opacity-80'>
                                    {userFullName}
                                </small>
                            </div>
                        </div>
                        <div className='float-left mr-2'>
                            <Avatar src={courseImageUrl} size='small'/>
                        </div>
                        <div className='float-left mr-2'>
                            <Avatar src={userImageUrl} size='small'/>
                        </div>
                        <div className='float-left mr-2'>
                            {this.handleStatus(stepTitle)}
                        </div>
                    </div>
                </div>
                <div className="divider-icon divider-margins bg-primary">
                    <i className="fa font-17 fa-user color-primary"></i>
                </div>
                <div className='row'>
                    {this.handleDetail(pageTranslates.Username, username)}
                    {this.handleDetail(pageTranslates.UserFullName, userFullName)}
                </div>
                <div className="divider-icon divider-margins bg-primary">
                    <i className="fa font-17 fa-credit-card color-primary"></i>
                </div>
                <div className='row'>
                    {this.handleDetail(pageTranslates.Price, `${price.toLocaleString()} ${pageTranslates.Currency}`)}
                    {this.handleDetail(pageTranslates.PaymentType, paymentTypeTitle)}
                    {paymentTypeTitle.toLowerCase() == 'offline' &&
                    <>
                        {this.handleDetail(pageTranslates.OwnerName, ownerName)}
                        {this.handleDetail(pageTranslates.CardNumber, cardNumber)}
                        {this.handleDetail(pageTranslates.TrackingCode, trackingCode)}
                    </>
                    }
                    {this.handleDetail(pageTranslates.CreatedDate, jCreateDate)}
                    {this.handleDetail(pageTranslates.ModifiedDate, jModifiedDate)}

                    <>
                        <div
                            className='text-center col-6 color-primary font-weight-bold d-flex justify-content-center align-items-center'>
                            {pageTranslates.OrderStep}
                        </div>
                        <div className='input-style has-icon input-style-2 mb-0 d-flex'>
                            <em><i className="fa fa-angle-down"></i></em>
                            <select style={{paddingLeft: 30, minWidth: 110}} onChange={this.selectChange}
                                    value={selectedStep}>
                                {steps && steps.map(({id, name}, index) => {
                                    return (
                                        <option value={id}>{name}</option>
                                    );
                                })}
                            </select>
                        </div>
                    </>
                </div>
                <div>
                    <Button full onClick={this.handleSubmit} loading={submitLoading}>
                        {pageTranslates.Submit}
                    </Button>
                    <Button full type='secondary' onClick={this.handleBack}>
                        {pageTranslates.Back}
                    </Button>
                </div>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(BillDetail));

